export default __webpack_public_path__ + "static/media/stackoverflow.83903977.svg";